import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import BanDoThichHopApi from '../../api/BanDoThichHopApi';
import ChuGiaiApi from '../../api/ChuGiaiApi';
import { SelectHuyen } from '../selecthuyen/SelectHuyen';
import { SelectXa } from '../selectxa/SelectXa';
import Select from 'react-select';
import ThongBao from '../../core/ThongBao';
import { Loading } from '../loading/Loading';


export const ModalThichHop = (props) => {
    const [show, setShow] = useState(false);
    const { register, handleSubmit, reset } = useForm();
    const [xa, setXa] = useState({});
    const [listThichHops, setListTh] = useState([]);
    const [selectedThichHop, setSelectedThichHop] = useState();
    const [selectedLua, setSelectedLua] = useState('');
    const [selectedNgo, setSelectedNgo] = useState('');
    const [selectedSan, setSelectedSan] = useState('');
    const [selectedKhoai, setSelectedKhoai] = useState('');
    const [selectedRau, setSelectedRau] = useState('');
    const [selectedBi, setSelectedBi] = useState('');
    const [selectedLac, setSelectedLac] = useState('');
    const [selectedHoa, setSelectedHoa] = useState('');
    const [selectedCam, setSelectedCam] = useState('');
    const [selectedBuoi, setSelectedBuoi] = useState('');
    const [selectedChanh, setSelectedChanh] = useState('');
    const [selectedNhan, setSelectedNhan] = useState('');
    const [selectedMit, setSelectedMit] = useState('');
    const [selectedBo, setSelectedBo] = useState('');
    const [selectedSauRieng, setSelectedSauRieng] = useState('');
    const [selectedXoai, setSelectedXoai] = useState('');
    const [selectedNa, setSelectedNa] = useState('');
    const [selectedChuoi, setSelectedChuoi] = useState('');
    const [selectedDieu, setSelectedDieu] = useState('');
    const [selectedCaoSu, setSelectedCaoSu] = useState('');
    const [selectedCafe, setSelectedCafe] = useState('');
    const [selectedDauTam, setSelectedDauTam] = useState('');
    const [selectedHoTieu, setSelectedHoTieu] = useState('');
    const [selectedDuocLieu, setSelectedDuocLieu] = useState('');
    const [selectedMang, setSelectedMang] = useState('');
    const [selectedDua, setSelectedDua] = useState('');



    const [selectedDauTuong, setSelectedDauTuong] = useState('');
    const [selectedChe, setSelectedChe] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        props.handleClose();
        setShow(false);
    };

    useEffect(() => {

        if (props.showModal === true) {
            setShow(true);
            reset({
                id: props.thongTin.id,
                maxa: props.thongTin.maxa,
                tenxa: props.thongTin.tenxa,

                dt_ha: props.thongTin.dt_ha,
                thichnghi_: props.thongTin.thichnghi_
            }, [reset]);
            ChuGiaiApi.getThichHop().then((res) => {
                let list = [];



                res.forEach(item => {
                    list.push({
                        value: item.matn,
                        label: item.matn,
                        thichnghi_: item.matn,
                        thlua: item.thlua,
                        thngo: item.thngo,
                        thsan: item.thsan,
                        thkhoai: item.thkhoai,
                        thrau: item.thrau,
                        thbi: item.thbi,
                        thlac: item.thlac,
                        thhoa: item.thhoa,
                        thcam: item.thcam,
                        thbuoi: item.thbuoi,
                        thchanhday: item.thchanhday,
                        thnhan: item.thnhan,
                        thmit: item.thmit,
                        thbo: item.thbo,
                        thsaurieng: item.thsaurieng,
                        thxoai: item.thxoai,
                        thna: item.thna,
                        thchuoi: item.thchuoi,
                        thdieu: item.thdieu,
                        thcaosu: item.thcaosu,
                        thcaffe: item.thcaffe,
                        thdautam: item.thdautam,
                        thmangtay: item.thmangtay,
                        thduoclieu: item.thduoclieu,
                        thdua: item.thdua,
                        thtieu: item.thtieu,
                        lua: item.lua,
                        ngo: item.ngo,
                        san: item.san,
                        khoai: item.khoai,
                        rau: item.rau,
                        bi: item.bi,
                        lac: item.lac,
                        hoa: item.hoa,
                        cam: item.cam,
                        buoi: item.buoi,
                        chanh_day: item.chanh_day,
                        nhan: item.nhan,
                        mit: item.mit,
                        bo: item.bo,
                        sau_rieng: item.sau_rieng,
                        xoai: item.xoai,
                        na: item.na,
                        chuoi: item.chuoi,
                        dieu: item.dieu,
                        cao_su: item.cao_su,
                        caffe: item.caffe,
                        dau_tam: item.dau_tam,
                        mang_tay: item.mang_tay,
                        duoc_lieu: item.duoc_lieu,
                        dua: item.dua,
                        ho_tieu: item.ho_tieu
                    });

                });
                let index = list.findIndex(x => x.thichnghi_ === props.thongTin.thichnghi_)
                if (index != -1) {
                    setSelectedThichHop({
                        value: list[index].thichnghi_,
                        label: list[index].thichnghi_,
                        thichnghi_: list[index].thichnghi_,
                        thlua: list[index].thlua,
                        thngo: list[index].thngo,
                        thsan: list[index].thsan,
                        thkhoai: list[index].thkhoai,
                        thrau: list[index].thrau,
                        thbi: list[index].thbi,
                        thlac: list[index].thlac,
                        thhoa: list[index].thhoa,
                        thcam: list[index].thcam,
                        thbuoi: list[index].thbuoi,
                        thchanhday: list[index].thchanhday,
                        thnhan: list[index].thnhan,
                        thmit: list[index].thmit,
                        thbo: list[index].thbo,
                        thsaurieng: list[index].thsaurieng,
                        thxoai: list[index].thxoai,
                        thna: list[index].thna,
                        thchuoi: list[index].thchuoi,
                        thdieu: list[index].thdieu,
                        thcaosu: list[index].thcaosu,
                        thcaffe: list[index].thcaffe,
                        thdautam: list[index].thdautam,
                        thmangtay: list[index].thmangtay,
                        thduoclieu: list[index].thduoclieu,
                        thdua: list[index].thdua,
                        thtieu: list[index].thtieu,
                        lua: list[index].lua,
                        ngo: list[index].ngo,
                        san: list[index].san,
                        khoai: list[index].khoai,
                        rau: list[index].rau,
                        bi: list[index].bi,
                        lac: list[index].lac,
                        hoa: list[index].hoa,
                        cam: list[index].cam,
                        buoi: list[index].buoi,
                        chanh_day: list[index].chanh_day,
                        nhan: list[index].nhan,
                        mit: list[index].mit,
                        bo: list[index].bo,
                        sau_rieng: list[index].sau_rieng,
                        xoai: list[index].xoai,
                        na: list[index].na,
                        chuoi: list[index].chuoi,
                        dieu: list[index].dieu,
                        cao_su: list[index].cao_su,
                        caffe: list[index].caffe,
                        dau_tam: list[index].dau_tam,
                        mang_tay: list[index].mang_tay,
                        duoc_lieu: list[index].duoc_lieu,
                        dua: list[index].dua,
                        ho_tieu: list[index].ho_tieu
                    });
                    setSelectedLua(list[index].thlua);
                    setSelectedNgo(list[index].thngo);
                    setSelectedSan(list[index].thsan);
                    setSelectedKhoai(list[index].thkhoai);
                    setSelectedRau(list[index].thrau);
                    setSelectedBi(list[index].thbi);
                    setSelectedLac(list[index].thlac);
                    setSelectedHoa(list[index].thhoa);
                    setSelectedCam(list[index].thcam);
                    setSelectedBuoi(list[index].thbuoi);
                    setSelectedChanh(list[index].thchanhday);
                    setSelectedNhan(list[index].thnhan);
                    setSelectedMit(list[index].thmit);
                    setSelectedBo(list[index].thbo);
                    setSelectedSauRieng(list[index].thsaurieng);
                    setSelectedXoai(list[index].thxoai);
                    setSelectedNa(list[index].thna);
                    setSelectedChuoi(list[index].thchuoi);
                    setSelectedDieu(list[index].thdieu);
                    setSelectedCaoSu(list[index].thcaosu);
                    setSelectedCafe(list[index].thcaffe);
                    setSelectedDauTam(list[index].thdautam);
                    setSelectedHoTieu(list[index].thtieu);
                    setSelectedDuocLieu(list[index].thduoclieu);
                    setSelectedMang(list[index].thmangtay);
                    setSelectedDua(list[index].thdua);
                }
                setListTh(list);
                setShow(true);
            });
        }
    }, [props.showModal]);


    const onChangeXa = (e) => {
        setXa(e);
    }

    const onChangeThichHop = (e) => {
        setSelectedThichHop(e);
        setSelectedLua(e.thlua);
        setSelectedNgo(e.thngo);
        setSelectedSan(e.thsan);
        setSelectedKhoai(e.thkhoai);
        setSelectedRau(e.thrau);
        setSelectedBi(e.thbi);
        setSelectedLac(e.thlac);
        setSelectedHoa(e.thhoa);
        setSelectedCam(e.thcam);
        setSelectedBuoi(e.thbuoi);
        setSelectedChanh(e.thchanhday);
        setSelectedNhan(e.thnhan);
        setSelectedMit(e.thmit);
        setSelectedBo(e.thbo);
        setSelectedSauRieng(e.thsaurieng);
        setSelectedXoai(e.thxoai);
        setSelectedNa(e.thna);
        setSelectedChuoi(e.thchuoi);
        setSelectedDieu(e.thdieu);
        setSelectedCaoSu(e.thcaosu);
        setSelectedCafe(e.thcaffe);
        setSelectedDauTam(e.thdautam);
        setSelectedHoTieu(e.thtieu);
        setSelectedDuocLieu(e.thduoclieu);
        setSelectedMang(e.thmangtay);
        setSelectedDua(e.thdua);
    }
    const onSubmit = (data) => {
        try {

            data.maxa = xa?.value;
            data.tenxa = xa?.label;
            data.thichnghi_ = selectedThichHop?.value
            data.id = props.thongTin.id;
            data.dt_ha = props.thongTin.dt_ha;
            data.lua = selectedThichHop.lua;
            data.ngo = selectedThichHop.ngo
            data.san = selectedThichHop.san;
            data.khoai = selectedThichHop.khoai;
            data.rau = selectedThichHop.rau;
            data.bi = selectedThichHop.bi;
            data.lac = selectedThichHop.lac;
            data.hoa = selectedThichHop.hoa;
            data.cam = selectedThichHop.cam;
            data.buoi = selectedThichHop.buoi;
            data.chanh_day = selectedThichHop.chanh_day;
            data.nhan = selectedThichHop.nhan;
            data.mit = selectedThichHop.mit;
            data.bo = selectedThichHop.bo;
            data.sau_rieng = selectedThichHop.sau_rieng;
            data.xoai = selectedThichHop.xoai;
            data.na = selectedThichHop.na;
            data.chuoi = selectedThichHop.chuoi;
            data.dieu = selectedThichHop.dieu;
            data.cao_su = selectedThichHop.cao_su;
            data.caffe = selectedThichHop.caffe;
            data.dau_tam = selectedThichHop.dau_tam;
            data.mang_tay = selectedThichHop.mang_tay;
            data.duoc_lieu = selectedThichHop.duoc_lieu;
            data.dua = selectedThichHop.dua;
            data.ho_tieu = selectedThichHop.ho_tieu;

            setLoading(true);
            if (data.id != null) {
                BanDoThichHopApi.update(data).then((res) => {
                    ThongBao.printSuccessMessage('Cập nhật thành công!');
                    handleClose();
                    props.changeMapComplete();
                    setLoading(false);
                }, (err) => {
                    setLoading(false);
                    ThongBao.printErrorMessage(err);
                });
            }
            else {
                console.log('noid');
            }
        }
        catch (ex) {
            console.log(ex);
        }

    }

    return (
        <Modal size='lg' dialogclassName="modalTK" show={show} onHide={handleClose} backdrop="static" keyboard={false} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Thông tin thích hợp đất đai</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="user">

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Xã</label>
                        <div className="col-sm-10">
                            <SelectXa Ma={props.thongTin.maxa} onChangeXaProps={(e) => onChangeXa(e)}></SelectXa>
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Diện tích</label>
                        <div className="col-sm-4">
                            <input name="dt_ha" type="text" className="form-control" placeholder="Diện tích" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">Mã thích hợp</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="thichhop"
                                placeholder="Chọn mã thích hợp"
                                value={selectedThichHop}
                                onChange={onChangeThichHop}
                                options={listThichHops}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Điều</label>
                        <div className="col-sm-4">
                            <input name="dieu" type="text" className="form-control" placeholder="Điều" ref={register} value={selectedDieu} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Hồ tiêu</label>
                        <div className="col-sm-4">
                            <input name="tieu" type="text" className="form-control" placeholder="Hồ tiêu" ref={register} value={selectedHoTieu} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Cà phê</label>
                        <div className="col-sm-4">
                            <input name="cafe" type="text" className="form-control" placeholder="Cà phê" ref={register} value={selectedCafe} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Cao su</label>
                        <div className="col-sm-4">
                            <input name="caosu" type="text" className="form-control" placeholder="Cao su" ref={register} value={selectedCaoSu} disabled />
                        </div>
                    </div>


                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Lúa</label>
                        <div className="col-sm-4">
                            <input name="lua" type="text" className="form-control" placeholder="Lúa" ref={register} value={selectedLua} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Ngô</label>
                        <div className="col-sm-4">
                            <input name="ngo" type="text" className="form-control" placeholder="Ngô" ref={register} value={selectedNgo} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Sắn</label>
                        <div className="col-sm-4">
                            <input name="san" type="text" className="form-control" placeholder="Sắn" ref={register} value={selectedSan} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Khoai</label>
                        <div className="col-sm-4">
                            <input name="khoai" type="text" className="form-control" placeholder="Khoai" ref={register} value={selectedKhoai} disabled />
                        </div>
                    </div>


                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Rau</label>
                        <div className="col-sm-4">
                            <input name="rau" type="text" className="form-control" placeholder="Rau" ref={register} value={selectedRau} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Bí</label>
                        <div className="col-sm-4">
                            <input name="bi" type="text" className="form-control" placeholder="Bí" ref={register} value={selectedBi} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Lạc</label>
                        <div className="col-sm-4">
                            <input name="lac" type="text" className="form-control" placeholder="Lạc" ref={register} value={selectedLac} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Hoa</label>
                        <div className="col-sm-4">
                            <input name="hoa" type="text" className="form-control" placeholder="Hoa" ref={register} value={selectedHoa} disabled />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Cam</label>
                        <div className="col-sm-4">
                            <input name="cam" type="text" className="form-control" placeholder="Cam" ref={register} value={selectedCam} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Bưởi</label>
                        <div className="col-sm-4">
                            <input name="buoi" type="text" className="form-control" placeholder="Bưởi" ref={register} value={selectedBuoi} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Chanh dây</label>
                        <div className="col-sm-4">
                            <input name="chanh" type="text" className="form-control" placeholder="Chanh dây" ref={register} value={selectedChanh} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Nhãn</label>
                        <div className="col-sm-4">
                            <input name="nhan" type="text" className="form-control" placeholder="Nhãn" ref={register} value={selectedNhan} disabled />
                        </div>
                    </div>


                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Mít</label>
                        <div className="col-sm-4">
                            <input name="mit" type="text" className="form-control" placeholder="Mít" ref={register} value={selectedMit} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Bơ</label>
                        <div className="col-sm-4">
                            <input name="bo" type="text" className="form-control" placeholder="Bơ" ref={register} value={selectedBo} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Sầu riêng</label>
                        <div className="col-sm-4">
                            <input name="saurieng" type="text" className="form-control" placeholder="Sầu riêng" ref={register} value={selectedSauRieng} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Xoài</label>
                        <div className="col-sm-4">
                            <input name="xoai" type="text" className="form-control" placeholder="Xoài" ref={register} value={selectedXoai} disabled />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Chuối</label>
                        <div className="col-sm-4">
                            <input name="chuoi" type="text" className="form-control" placeholder="Chuối" ref={register} value={selectedChuoi} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Dâu tằm</label>
                        <div className="col-sm-4">
                            <input name="dautam" type="text" className="form-control" placeholder="Dâu tằm" ref={register} value={selectedDauTam} disabled />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Măng tây</label>
                        <div className="col-sm-4">
                            <input name="mang" type="text" className="form-control" placeholder="Măng tây" ref={register} value={selectedMang} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Dược liệu</label>
                        <div className="col-sm-4">
                            <input name="duoclieu" type="text" className="form-control" placeholder="Dược liệu" ref={register} value={selectedDuocLieu} disabled />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Dứa</label>
                        <div className="col-sm-4">
                            <input name="dua" type="text" className="form-control" placeholder="Dứa" ref={register} value={selectedDua} disabled />

                        </div>
                        <label className="col-sm-2 col-form-label text-right">Na</label>
                        <div className="col-sm-4">
                            <input name="na" type="text" className="form-control" placeholder="Na" ref={register} value={selectedNa} disabled />

                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-group row">
                    <a href="#" type="button" className="btn btn-info btn-sm ml-1" onClick={handleSubmit(onSubmit)}><i className='fas fa-save'></i> Lưu</a>
                    <a href="#" type="button" className="btn btn-danger btn-sm ml-1" onClick={handleClose} disabled><i className="fas fa-sign-out-alt"></i> Hủy</a>
                </div>
            </Modal.Footer>
            <Loading loading={loading}></Loading>
        </Modal>
    );
};